<div style="padding:20px"> 
    <div *ngIf="userinfo.id!='-1'" style="margin:15px">選取對象:
        <button  class="btn btn-info select_contain" (click)="select_user({user_id:'-1'})">
            <img loading="lazy"  [src]="userinfo.profile_pic">{{userinfo.name}}
        </button>
        總收益:{{userinfo.diamond}}顆鑽石
    </div>
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index"   class="nav-item" (click)="choose(item.id)">
          <a  *ngIf="i==0 || (i>=1&&userinfo.id!='-1')" onclick="return false;" [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</a>
        </li>
    </ul>
    <div *ngIf="now=='0'">
        <input  type="text" [(ngModel)]="search_model"  (keyup.enter)="init_list()" placeholder="請填入名字或電話進行查詢" class="form-control" style="width: 220px;display: inline;">
        <button  class="btn btn-primary"  *ngIf="search_model.length>0" (click)="init_list()">查詢</button>
        <button  class="btn btn-info"  *ngIf="search_model.length>0" (click)="search_model='';init_list()">清除查詢</button>
        <table style="margin-top: 10px;"  class="table table-responsive-sm" *ngIf="data.length>0" style="margin-top: 6px;">
            <thead>
            <tr class="table-primary" style="font-size:18px;">
                <th style="width:5%">姓名</th>
                <th style="width:5%">圖片</th>
                <th style="width:5%">鑽石</th>
                <th style="width:5%">年份</th>
                <th style="width:5%">月份</th>
                <th style="width:5%">建立時間</th>
                <th style="width:5%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                <td>{{item.name}}</td>
                <td><img loading="lazy" style="width: 50px" src="{{item.profile_pic}}"></td>
                <td>{{item.diamond|number}}</td>
                <td>{{item.year}}</td>
                <td>{{item.month}}</td>
                <td>{{item.create_dt}}</td>
                <td><button (click)="select_user(item)"  class="btn btn-primary">觀看當月資訊</button></td>             
            </tr>
            </tbody>
        </table>
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
        <div *ngIf="data.length==0">無資料</div>
    </div>
    <div *ngIf="now=='1'">
        <table style="margin-top: 10px;"  class="table table-responsive-sm" *ngIf="data2.length>0" style="margin-top: 6px;">
            <thead>
            <tr class="table-primary" style="font-size:18px;">
                <th style="width:5%">姓名</th>
                <th style="width:5%">圖片</th>
                <th style="width:5%">獲得</th>
                <th style="width:5%">貢獻</th>
                <th style="width:5%">年份</th>
                <th style="width:5%">月份</th>
                <th style="width:5%">貢獻匯率</th>
                <th style="width:5%">身分</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of data2; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                <td>{{item.name}}</td>
                <td><img loading="lazy" style="width: 50px" src="{{item.profile_pic}}"></td>
                <td>{{item.gain_total}}</td>
                <td>{{item.diamond}}</td>
                <td>{{item.year}}</td>
                <td>{{item.month}}</td>
                <td>{{item.rate}}</td>
                <td>{{item.blood_type==1?'二級助手':'三級助手'}}</td>
            </tr>
            </tbody>
        </table>
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
        <div *ngIf="data.length==0">無資料</div>
    </div>
</div>
 
<app-spinner [loading]="loading"></app-spinner>